<template>
  <b-container>
    <b-card-title>Excel downloads</b-card-title>

    <!-- <Widgets /> -->
    <b-nav tabs>
      <b-nav-item :to="{ name: 'opmerkingen-export'}">
        Opmerkingen inspecties/prognoses
      </b-nav-item>
      <b-nav-item :to="{ name: 'keuringspunten-export'}">
        Keuringspunten
      </b-nav-item>
      <b-nav-item :to="{ name: 'keuringen-export'}">
        Keuringen
      </b-nav-item>
    </b-nav>
    <router-view />
  </b-container>
</template>
<script>
import Widgets from '../Widgets.vue';

export default {
  name: 'ExcelExports',
  components: { Widgets },
  mixins: [],
  data() {
      return {
          
      }
  },
  mounted() {

  },
  methods: {
      
  }
}
</script>